import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/site/Seo";
import Band, { Eyebrow } from "@/components/site/Band";

export default function About() {
  return (
    <>
      <Seo
        title="About Health and More"
        description="Health and More connects independent physician practices to hospital-system 340B and RPM programs, and runs the administrative work that keeps them survivable."
        path="/about"
      />

      <Band tone="spruce">
        <Eyebrow>About</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.03] mb-6 max-w-3xl">
          One company that has actually done the work.
        </h1>
        <p className="text-bone/85 text-base sm:text-lg max-w-2xl">
          You've been pitched RPM this year already. Maybe 340B too. This category over-promises, so here
          is what we are, in plain terms.
        </p>
      </Band>

      <Band tone="bone">
        <div className="max-w-prose space-y-6 text-base text-ink leading-relaxed">
          <p>
            Health and More connects independent practices to hospital-system programs. We work through
            hospital systems that are 340B covered entities and bring their programs to specialists and
            chronic-care practices that could never register on their own.
          </p>
          <p>
            We don't pretend a private practice becomes 340B-eligible. It doesn't. The covered entity is
            the hospital partner, and it stays that way. What we add is the connection to that partner and
            the staff to run the program — credentialing, billing, device logistics, documentation, and an
            audit file kept ready.
          </p>
          <p>
            Two programs fit two very different practices. If most of your revenue is specialty drugs, 340B
            is your page. If most of your revenue is patient visits, RPM is. Nephrology fits both. We split
            the two on purpose, because sending an oncologist and a family doctor down the same funnel helps
            neither of them.
          </p>
          <p>
            We under-promise timelines and we show the assumptions behind every number. That's the whole
            posture: we're not going to lie to you about this.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/network" className="inline-flex items-center gap-2 text-sm font-semibold text-spruce hover:text-brass transition-colors" data-testid="about-network-link">
            See the network <ArrowRight size={16} />
          </Link>
          <Link to="/how-it-works" className="inline-flex items-center gap-2 text-sm font-semibold text-spruce hover:text-brass transition-colors" data-testid="about-how-link">
            See the timeline <ArrowRight size={16} />
          </Link>
        </div>
      </Band>
    </>
  );
}
